import { render } from "./IndexCategoryPage.vue?vue&type=template&id=39a763f2"
import script from "./IndexCategoryPage.vue?vue&type=script&lang=js"
export * from "./IndexCategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__